"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DiagnosticsPane_1 = require("./components/DiagnosticsPane");
exports.DiagnosticsPane = DiagnosticsPane_1.default;
var FeatureFlagsPane_1 = require("./components/FeatureFlagsPane");
exports.FeatureFlagsPane = FeatureFlagsPane_1.default;
var HelpPane_1 = require("./components/HelpPane");
exports.HelpPane = HelpPane_1.default;
var MeCardPane_1 = require("./components/MeCardPane");
exports.MeCardPane = MeCardPane_1.default;
var SettingsPane_1 = require("./components/SettingsPane");
exports.SettingsPane = SettingsPane_1.default;
var FeedbackPane_1 = require("./components/FeedbackPane");
exports.FeedbackPane = FeedbackPane_1.default;
var WafflePane_1 = require("./components/WafflePane");
exports.WafflePane = WafflePane_1.default;
var GetStartedPane_1 = require("./components/GetStartedPane");
exports.GetStartedPane = GetStartedPane_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/lazyIndex.js
// module id = 2082
// module chunks = 38